if (eModal) {
  const oldConfirm = eModal.confirm;
  eModal.confirm = async function (...args) {
    const $previousModal = $(".modal.in");

    if ($previousModal.length) {
      $previousModal.modal("hide");
    }

    try {
      return await oldConfirm.apply(this, args);
    } finally {
      if ($previousModal.length) {
        $previousModal.modal("show");
      }
    }
  };
}
